import { render, staticRenderFns } from "./CancellationGeneric.vue?vue&type=template&id=37b2dece"
import script from "./CancellationGeneric.vue?vue&type=script&lang=js"
export * from "./CancellationGeneric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports